import React from 'react';
import {
  LinkAnchor,
  ContainerCustom,
  DeviceBreakpoint,
  DropdownMenu,
} from 'components';
import { useIntl } from 'react-intl';
import { useHistory, Link } from 'react-router-dom';
import { FacebookSVG, YoutubeSVG, InstagramSVG } from 'lib/icons';
import { Row, Menu } from 'antd';
import Navbar from 'pages/Layouts/MainPageLayout/Navbar';
import { SearchBarPanel } from './SearchBarPanel';
import { SearchBarDeviceBreakpoint } from './SearchBarPanel.styles';
import { SearchBarPanelMobile } from './SearchBarPanelMobile';
import {
  HeaderContainer,
  HeaderBg,
  Headings,
  SocialContainer,
  DropdownMenuStyled,
} from './Header.styles';
import { TitleMain } from '../../Main.styles';

const Header = ({ heading, subheading, children, headerPadding }) => {
  const intl = useIntl();
  const history = useHistory();

  const onLaguageChangeHandler = (e) => {
    console.log(e);
    const currentLanguage = history.location.pathname.split('/')[1];

    if (e.key === currentLanguage) {
      return;
    }
    const newPath = history.location.pathname.replace(currentLanguage, e.key);

    localStorage.setItem('language', e.key);
    history.push({
      pathname: newPath,
    });
    window.location.reload(true);
  };

  return (
    <HeaderBg>
      <Navbar />
      <HeaderContainer paddingTablet={headerPadding}>
        <ContainerCustom alignSelf="center" width="100%">
          <Headings>
            <TitleMain
              marginM="107px 0 16px 0"
              marginBottom="2%"
              size="72px"
              sizeM="42px"
              sizeMobileL="36px"
              weight="bold"
              color="#fff"
              lineHeight="110%"
              weightMobile="500"
              maxWidth="90%"
              maxWidthM="670px"
            >
              {heading ||
                intl.formatMessage({
                  id: 'main-page.heading',
                  defaultMessage: 'Book an amazing vacation rental by the sea',
                })}
            </TitleMain>
            <TitleMain
              size="24px"
              sizeM="14px"
              weight="500"
              color="#fff"
              weightMobile="normal"
            >
              {subheading ||
                intl.formatMessage({
                  id: 'main-page.sub-heading',
                  defaultMessage:
                    'Best professionaly managed villas & holiday homes',
                })}
            </TitleMain>
          </Headings>

          {children}
        </ContainerCustom>
        <SocialContainer>
          <LinkAnchor
            href="https://www.facebook.com/Aktis.Villas"
            target="blank"
          >
            <FacebookSVG />
          </LinkAnchor>
          <LinkAnchor
            href="https://www.youtube.com/channel/UCG_DmJBfs4dooHlkbvswryA/?guided_help_flow=5 "
            target="blank"
          >
            <YoutubeSVG />
          </LinkAnchor>
          <LinkAnchor
            href="https://www.instagram.com/aktis.villas/"
            target="blank"
          >
            <InstagramSVG />
          </LinkAnchor>
        </SocialContainer>
      </HeaderContainer>
    </HeaderBg>
  );
};

export { Header };
